import { zodResolver } from '@hookform/resolvers/zod';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import { forgotPassword } from '@/api/auth/auth.actions';
import { ForgotPasswordData } from '@/api/auth/auth.types';
import Button from '@/components/controls/Button';
import {
  defaultInputStyle,
  defaultLabelStyle,
} from '@/components/controls/CustomEntityFormField.tsx';
import CustomInput from '@/components/controls/CustomInput';
import { ForgotPasswordSchema } from '@/components/zod/types';

const ForgotPasswordForm: FC = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordData>({
    resolver: zodResolver(ForgotPasswordSchema),
  });

  const onSubmit = async (data: ForgotPasswordData): Promise<void> => {
    const response = await forgotPassword(data);

    if (!response.success) {
      toast.error(response.error.message);
    }

    toast.success(response.message);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="self-center w-[calc(100vw-2rem)] max-w-[400px] md:max-w-[450px] fluid-desktop:max-w-[500px] xl:max-w-[650px] fluid-desktop:w-[40vw] xl:w-[30vw] min-w-0 nest-hub-form-width">
        <CustomInput
          name="identifier"
          placeholder="Enter Email Address"
          type="email"
          hasIcon={false}
          label="Email"
          inputStyle={defaultInputStyle}
          labelStyle={defaultLabelStyle}
          control={control}
          error={errors.identifier}
        />
        <Button
          buttonStyle="justify-center items-center px-6 py-2 mt-5 text-base font-semibold text-white whitespace-nowrap bg-honoursOrange rounded-xl max-md:px-5 w-full text-lg"
          text="Request reset password link"
          buttonType={{ type: 'submit' }}
          hasImage={false}
        />
      </div>
    </form>
  );
};

export default ForgotPasswordForm;
